
import BezahlungWeiterleitenBestellungLogic from "@/logic/bestellung/bezahlung_weiterleiten_bestellung_logic"
import Vue from "vue"
import Component from "vue-class-component"

@Component
export default class BezahlungWeiterleitenBestellung extends Vue {
  logic: BezahlungWeiterleitenBestellungLogic = null

  mounted() {
    this.logic = new BezahlungWeiterleitenBestellungLogic()
    this.logic.init(this.$route.params.bestellungId)
  }
}
